import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=43cba4ab&scoped=true"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=43cba4ab&prod&scoped=true&lang=css"
import style1 from "./VideoDialog.vue?vue&type=style&index=1&id=43cba4ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cba4ab",
  null
  
)

export default component.exports